import request from '@/utils/request'


// 查询订单地址列表
export function listOrderAddress(query) {
  return request({
    url: '/user/order-address/list',
    method: 'get',
    params: query
  })
}

// 查询订单地址分页
export function pageOrderAddress(query) {
  return request({
    url: '/user/order-address/page',
    method: 'get',
    params: query
  })
}

// 查询订单地址详细
export function getOrderAddress(data) {
  return request({
    url: '/user/order-address/detail',
    method: 'get',
    params: data
  })
}

// 新增订单地址
export function addOrderAddress(data) {
  return request({
    url: '/user/order-address/add',
    method: 'post',
    data: data
  })
}

// 修改订单地址
export function updateOrderAddress(data) {
  return request({
    url: '/user/order-address/edit',
    method: 'post',
    data: data
  })
}

// 删除订单地址
export function delOrderAddress(data) {
  return request({
    url: '/user/order-address/delete',
    method: 'post',
    data: data
  })
}
